const makeUid = () => {
  const key = Math.random().toString(36).substring(2)
  return 'uid-' + key
}

export default makeUid
